import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ROUTES_CONSTANTS } from "../constants/routesConstants.js";
import Login from "../pages/Login/index.js";
import MaintenancePage from "../pages/Maintenance/index.js";
import PublicRoute from "../components/PublicRoute/index.js";
import ProtectedRoute from "../components/ProtectedRoute/index.js";
import Clients from "../pages/Clients/index.js";
import Packages from "../pages/Packages/index.js";
import Dashboard from "../pages/Dashboard/index.js";
import Users from "../pages/Users/index.js";
import Navigation from "../pages/Navigation/index.js";
import Lots from "../pages/Lots/index.js";
import Guides from "../pages/Guides/index.js";
import Deliverers from "../pages/Deliverers/index.js";
import DeliverersDetails from "../pages/DeliverersDetails/index.js";
import ClientsDetails from "../pages/ClientsDetails/index.js";
import Categories from "../pages/Categories/index.js";
import DeliveryGuides from "../pages/DeliveryGuides/index.js";
import Report from "../pages/Report/index.js";
import Tracking from "../pages/Tracking/index.js";
import GuidesDetails from "../pages/GuidesDetails/index.js";
import PermissionRoute from "../components/Router/PermissionRoute/index.js";
import Tickets from "../pages/Tickets/index.js";

const { REACT_APP_IN_MAINTENANCE } = process.env;

const AppRouter = () => {

  if (REACT_APP_IN_MAINTENANCE === "true") {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<MaintenancePage />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        
        {/* Public Routes */}
        <Route element={<PublicRoute />}>
          <Route path={ROUTES_CONSTANTS.MAIN} element={<Login />} />
          <Route path={ROUTES_CONSTANTS.LOGIN} element={<Login />} />
        </Route>
        
        
        {/* Protected Routes with Navigation Layout */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Navigation />}>
            <Route path={ROUTES_CONSTANTS.DASHBOARD} element={<Dashboard />} />

            {/* Clientes */}
            <Route
              path={ROUTES_CONSTANTS.CLIENTS}
              element={
                <PermissionRoute requiredPermissions={["cli_vw"]}>
                  <Clients />
                </PermissionRoute>
              }
            />
            <Route
              path={ROUTES_CONSTANTS.CLIENTS_DETAILS}
              element={
                <PermissionRoute requiredPermissions={["cli_vw"]}>
                  <ClientsDetails />
                </PermissionRoute>
              }
            />

            {/* Usuarios */}
            <Route
              path={ROUTES_CONSTANTS.USERS}
              element={
                <PermissionRoute requiredPermissions={["usr_vw"]}>
                  <Users />
                </PermissionRoute>
              }
            />

            {/* Paquetes */}
            <Route
              path={ROUTES_CONSTANTS.PACKAGES}
              element={
                <PermissionRoute requiredPermissions={["rte_pac_vw"]}>
                  <Packages />
                </PermissionRoute>
              }
            />

            {/* Lotes */}
            <Route
              path={ROUTES_CONSTANTS.LOTS}
              element={
                <PermissionRoute requiredPermissions={["lot_vw"]}>
                  <Lots />
                </PermissionRoute>
              }
            />

            {/* Guías */}
            <Route
              path={ROUTES_CONSTANTS.GUIDES}
              element={
                <PermissionRoute requiredPermissions={["rte_vw"]}>
                  <Guides />
                </PermissionRoute>
              }
            />
            <Route
              path={ROUTES_CONSTANTS.GUIDES_DETAILS}
              element={
                <PermissionRoute requiredPermissions={["rte_vw"]}>
                  <GuidesDetails />
                </PermissionRoute>
              }
            />

            {/* Repartidores */}
            <Route
              path={ROUTES_CONSTANTS.DELIVERERS}
              element={
                <PermissionRoute requiredPermissions={["cut_vw"]}>
                  <Deliverers />
                </PermissionRoute>
              }
            />
            <Route
              path={ROUTES_CONSTANTS.DELIVERERS_DETAILS}
              element={
                <PermissionRoute requiredPermissions={["cut_vw"]}>
                  <DeliverersDetails />
                </PermissionRoute>
              }
            />

            {/* Categorías */}
            <Route
              path={ROUTES_CONSTANTS.CATEGORIES}
              element={
                <PermissionRoute requiredPermissions={["cat_vw", "cat_ovw"]} requireAll={true}>
                  <Categories />
                </PermissionRoute>
              }
            />

            {/* Guías de entrega */}
            <Route
              path={ROUTES_CONSTANTS.DELIVERY_GUIDES}
              element={
                <PermissionRoute requiredPermissions={["dgu_vw"]}>
                  <DeliveryGuides />
                </PermissionRoute>
              }
            />

            {/* Reportes */}
            <Route
              path={ROUTES_CONSTANTS.TICKETS}
              element={
                //<PermissionRoute requiredPermissions={["rep_vw"]}>
                  <Tickets />
                //</PermissionRoute>
              }
            />
            
            {/* Reportes */}
            <Route
              path={ROUTES_CONSTANTS.REPORT}
              element={
                <PermissionRoute requiredPermissions={["rep_vw"]}>
                  <Report />
                </PermissionRoute>
              }
            />

            {/* Tracking */}
            <Route
              path={ROUTES_CONSTANTS.TRACKING}
              element={
                <PermissionRoute requiredPermissions={["trk_vw"]}>
                  <Tracking />
                </PermissionRoute>
              }
            />
          </Route>
        </Route>

        {/* Catch-all route for non-existent URLs - redirect to login */}
        <Route path="*" element={<Navigate to={ROUTES_CONSTANTS.LOGIN} replace />} />

      </Routes>
    </Router>
  );
  
};

export default AppRouter;